module.exports = __webpack_public_path__ + "img/mileage.0e8403ac.svg";